import {
  activeConnectionsReducer,
  State as activeConnectionsState
} from './slices/activeConnections/activeConnectionsSlice';
import { downloadReportReducer, State as DownloadReportState } from './slices/downloadReport';
import {
  incompleteGroupedQuestionsReducer,
  State as IncompleteGroupedQuestionsState
} from './slices/incompleteGroupedQuestions';
import { mainSubscriptionReducer, State as mainSubscriptionState } from './slices/mainSubscription';
import { organizationInfoReducer, State as OrganizationInfoState } from './slices/organizationInfo';
import { questionnaireStatusReducer, State as QuestionnaireStatusState } from './slices/questionnaireStatus';
import { reducer as notifications, State as NotificationsState } from './reducers/notifications';
import { reducer as userOrganizations, State as UserOrganizationsState } from './reducers/userOrganizations';
import { reducer as organization, State as OrganizationState } from './reducers/organization';
import { reducer as organizationLink, State as OrganizationLinkState } from './reducers/organizationLink';
import {
  reducer as questionnaireSections,
  State as QuestionnaireSectionsState
} from './reducers/questionnaireSections';
import { reducer as userInfo, State as UserInfoState } from './reducers/userInfo';
import { reducer as serverTokens, State as ServerTokensState } from './reducers/serverTokens';
import { reducer as options, State as OptionsState } from './reducers/options';
import { reducer as client, State as ClientState } from './reducers/client';
import { reducer as clients, State as ClientsState } from './reducers/clients';
import { reducer as clientOverridesCount, State as ClientOverridesCountState } from './reducers/clientOverridesCount';
import {
  reducer as qualificationProviders,
  State as QualificationProvidersState
} from './reducers/qualificationProviders';
import { reducer as rankings, State as RankingsState } from './reducers/rankings';
import { reducer as settings, State as SettingsState } from './reducers/settings';
import { reducer as subscriptions, State as SubscriptionsState } from './reducers/subscriptions';
import { reducer as snackbars, State as SnackbarsState } from './reducers/snackbars';
import { reducer as featureFlags, State as FeatureFlagsState } from './features/featureFlags/reducer';
import {
  reducer as organizationUserGroupsAndRoles,
  State as OrganizationUserGroupsAndRolesState
} from './reducers/organizationUserGroupsAndRoles';
import {
  reducer as primaryOrganizationReleases,
  State as PrimaryOrganizationReleasesState
} from './reducers/primaryOrganizationReleases';
import { reducer as userConsent, State as UserConsentState } from './reducers/userConsent';

export type CommonRootState = {
  serverTokens: ServerTokensState;
  client: ClientState;
  clients: ClientsState;
  clientOverridesCount: ClientOverridesCountState;
  downloadReport: DownloadReportState;
  featureFlags: FeatureFlagsState;
  notifications: NotificationsState;
  options: OptionsState;
  organization: OrganizationState;
  organizationInfo: OrganizationInfoState;
  organizationLink: OrganizationLinkState;
  organizationUserGroupsAndRoles: OrganizationUserGroupsAndRolesState;
  primaryOrganizationReleases: PrimaryOrganizationReleasesState;
  qualificationProviders: QualificationProvidersState;
  questionnaireSections: QuestionnaireSectionsState;
  rankings: RankingsState;
  settings: SettingsState;
  subscriptions: SubscriptionsState;
  snackbars: SnackbarsState;
  userInfo: UserInfoState;
  userOrganizations: UserOrganizationsState;
  userConsent: UserConsentState;
  mainSubscription: mainSubscriptionState;
  activeConnections: activeConnectionsState;
  questionnaireStatus: QuestionnaireStatusState;
  incompleteGroupedQuestions: IncompleteGroupedQuestionsState;
};

export const commonRootReducer = {
  serverTokens,
  client,
  clients,
  clientOverridesCount,
  downloadReport: downloadReportReducer,
  featureFlags,
  notifications,
  options,
  organization,
  organizationInfo: organizationInfoReducer,
  organizationLink,
  organizationUserGroupsAndRoles,
  primaryOrganizationReleases,
  qualificationProviders,
  questionnaireSections,
  rankings,
  settings,
  subscriptions,
  snackbars,
  userInfo,
  userOrganizations,
  userConsent,
  mainSubscription: mainSubscriptionReducer,
  activeConnections: activeConnectionsReducer,
  questionnaireStatus: questionnaireStatusReducer,
  incompleteGroupedQuestions: incompleteGroupedQuestionsReducer
};
